import React from "react";
import { formatDateAndTime } from "../../../utils/helper";
import { useStore } from "../../../store/store.context";

import "./email-generation.scss";

const EmailGeneration = ({ createdDate }) => {
  const { store } = useStore();
  const rawMailContent = (store?.status || {}).mailContent;
  const mailContent =
    typeof rawMailContent === "string"
      ? rawMailContent
      : rawMailContent
      ? JSON.stringify(rawMailContent)
      : "";
  const mailSubject = mailContent.split("\n")[1] || "";
  const mailBody = mailContent
    .split("\n")
    .slice(2)
    .join("\n")
    .replace(/,/, ",\n\n")
    .trim();

  return (
    <div className="email-generation-container">
      <div className="header">
        <div className="header-content">
          <h2 className="email-subject">{mailSubject}</h2>
          <p className="email-date">{formatDateAndTime(createdDate)}</p>
        </div>
      </div>

      <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
        {mailBody}
      </pre>
      {/* <div className="email-body">
        <div className="email-body-content">
          <p className="email-content">
            {formatEmailContent(store?.status?.mailContent)}
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default EmailGeneration;
